import React, { useState } from 'react'
import axios from 'axios'
import api from '@/services/api'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useNavigate, useLocation } from 'react-router-dom'
import { Token } from '@mui/icons-material'
import { login, setLoading, setError } from '@store/slices/authSlice'
import { useAppDispatch, useAppSelector } from '@store/index'
import { User, UserRole } from '@/types'
import { IconButton } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { addNotification } from '@store/slices/appSlice'
import LOGO from '../../assets/pillarThera.png'

const AdminLogIn = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()

  // Determine role and heading based on URL
  const isCertificateLogin = location.pathname === '/certificate-login'
  const role = isCertificateLogin ? 'certificate_manager' : 'admin'
  const heading = isCertificateLogin
    ? 'Certificate Manager Login'
    : 'Admin Login'

  const handleTogglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState)
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const response = await api.post('admin/login', {
        email,
        password,
        role,
      })

      const { admin, access_token, refresh_token } = response.data

      const authUser: User = {
        id: admin.id,
        firstName: admin.name,
        lastName: admin.lastname,
        email: admin.email,
        role: isCertificateLogin
          ? UserRole.CERTIFICATE_MANAGER
          : UserRole.ADMIN,
      }

      dispatch(
        login({
          user: authUser,
          token: access_token,
          refreshToken: refresh_token,
        })
      )

      // Show success notification
      //   dispatch(
      //     addNotification({
      //       type: 'success',
      //       title: 'Welcome back!',
      //       message: `Hello ${authUser.firstName}, you have successfully logged in.`,
      //     })
      //   )

      // toast.success('Login successful!')
      // setTimeout(() => {
      //   navigate('/dashboard')
      // }, 1000)
    } catch (err) {
      console.error('❌ Login failed:', err)
      setError(
        err.response?.data?.message || 'Login failed. Please check credentials.'
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Header */}
      <header className="flex items-center justify-between px-4 py-4 shadow-sm md:px-8">
        <img src={LOGO} alt="PillarThera Logo" className="h-10 md:h-12 ml-9" />
      </header>

      {/* Centered Login Card */}
      <div className="flex items-center justify-center flex-1">
        <div className="w-full max-w-md px-10 py-10 text-center bg-white shadow-md rounded-2xl">
          <h2 className="mb-6 text-lg font-medium text-gray-700">{heading}</h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="text-left">
              <label className="block mb-1 text-sm text-gray-600">Email</label>
              <input
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full border border-[#78C9C9] focus:ring-2 focus:ring-[#78C9C9] rounded-md px-3 py-2 outline-none"
                required
              />
            </div>
            <div className="text-left">
              <label className="block mb-1 text-sm text-gray-600">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'} // Toggle between text and password
                  placeholder="Enter password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 pr-12 outline-none focus:ring-2 focus:ring-[#78C9C9]" // Add pr-12 for space inside the input
                  required
                />
                <IconButton
                  onClick={handleTogglePasswordVisibility}
                  // className="absolute right-3 top-2 ml-[335px] mt-[-83px]"
                  sx={{ marginLeft: '322px', marginTop: '-70px' }}
                  aria-label="toggle password visibility"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}{' '}
                  {/* Show/Hide eye icon */}
                </IconButton>
              </div>
            </div>

            {error && <p className="text-sm text-left text-red-500">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-[#5DC0BD] hover:bg-[#48A8A5] text-white font-semibold py-2 rounded-md transition-all cursor-pointer ${
                loading ? 'opacity-70 cursor-not-allowed' : ''
              }`}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          {/* <p className="mt-5 text-sm text-gray-600">
            Login as a{' '}
            <a href="#" className="text-[#48A8A5] hover:underline font-medium">
              Certification Provider
            </a>
          </p> */}
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default AdminLogIn
